module.exports = __webpack_public_path__ + "static/media/cdb3.5dc40662.png";